import { BASE_API_URL } from 'lib/setting';
import { method, values } from 'lodash';
import { axs } from './config/axiosConfig';

const basePath = `${BASE_API_URL}/user`;

export function updateUserCurrecny(payload: { currency: string }) {
  return axs({ url: `${basePath}/currency`, method: 'put', data: payload });
}

// AGroupCode%BGroupCode
export function fetchUserProfileImgs(payload: { groupCode: string }) {
  return axs({
    url: `${basePath}/profileimg`,
    params: payload,
  });
}

const myPath = `${BASE_API_URL}/my`;
// auth
export function fetchProfile() {
  // ISSUE: timeout
  // { accessToken }: { accessToken?: string }
  // if (accessToken) {
  //   return axs({
  //     url: `${myPath}/profile`,
  //     method: 'get',
  //     headers: {
  //       'x-access-token': accessToken,
  //     },
  //   });
  // }
  return axs({ url: `${myPath}/profile`, method: 'get' });
}

export function updateEmployeeProfile(payload: {
  assignedTask: string;
  phonecode: number;
  phone: string;
}) {
  return axs({ url: `${myPath}/profile`, method: 'put', data: payload });
}

export function updateEmployeePassword(payload: { currentPassword: string; newPassword: string }) {
  return axs({ url: `${myPath}/password`, method: 'put', data: payload });
}

export function updateUserVisibility(payload: { visibility: number }) {
  return axs({ url: `${myPath}/profile/visibility`, method: 'put', data: payload });
}

export function updateUserType(payload: { userTypeIdx: number }) {
  return axs({ url: `${myPath}/profile/usertype`, method: 'put', data: payload });
}

export function updateUserAgreement(payload: { legalList: any[] }) {
  return axs({ url: `${myPath}/legal/agreement`, method: 'put', data: payload });
}

export function fetchMyRemakeList() {
  return axs({ url: `${myPath}/remaketype/list`, method: 'get' });
}

export function editMyRemakeList(payload: object | any) {
  return axs({ url: `${myPath}/remaketype`, method: 'post', data: payload });
}

export function fetchUserIndicationList() {
  return axs({ url: `${myPath}/indication/part`, method: 'get' });
}

export function updateUserIndication(payload: {
  editIndicationIdx: string | null;
  indicationName: string;
}) {
  return axs({ url: `${myPath}/indication/part`, method: 'post', data: payload });
}

export function deleteUserIndication(payload: { indicationIdx: string }) {
  return axs({ url: `${myPath}/indication/part`, method: 'delete', data: payload });
}

export function fetchUserMaterialList() {
  return axs({ url: `${myPath}/indication/material`, method: 'get' });
}

export function updateUserMaterial(payload: {
  editMaterialIdx: string | null;
  materialName: string;
}) {
  return axs({ url: `${myPath}/indication/material`, method: 'post', data: payload });
}

export function deleteUserMaterial(payload: { materialIdx: string }) {
  return axs({ url: `${myPath}/indication/material`, method: 'delete', data: payload });
}

export function fetchUsertypeChangeable() {
  return axs({ url: `${myPath}/usertype/changeable`, method: 'get' });
}

export function createKpiLoginSuccess() {
  return axs({ url: `${basePath}/kpi/login-success`, method: 'post' });
}
